import React, { useEffect, useState } from 'react';

// AdSense Publisher ID from environment variables
// If not defined, fall back to the actual publisher ID
const ADSENSE_PUB_ID = process.env.REACT_APP_ADSENSE_PUBLISHER_ID || 'ca-pub-8882464801503395';

// Helper function to get the correct ad slot from environment variables
const getAdSlotFromEnv = (slotName, fallbackSlot) => {
  const envVariable = {
    'home-top': 'REACT_APP_ADSENSE_HOME_TOP_SLOT',
    'home-bottom': 'REACT_APP_ADSENSE_HOME_BOTTOM_SLOT',
    'beautifier-top': 'REACT_APP_ADSENSE_BEAUTIFIER_TOP_SLOT',
    'beautifier-bottom': 'REACT_APP_ADSENSE_BEAUTIFIER_BOTTOM_SLOT',
    'schema-gen-top': 'REACT_APP_ADSENSE_SCHEMA_GEN_TOP_SLOT',
    'schema-gen-bottom': 'REACT_APP_ADSENSE_SCHEMA_GEN_BOTTOM_SLOT',
    'validator-top': 'REACT_APP_ADSENSE_VALIDATOR_TOP_SLOT',
    'validator-bottom': 'REACT_APP_ADSENSE_VALIDATOR_BOTTOM_SLOT',
    'string-conv-top': 'REACT_APP_ADSENSE_STRING_CONV_TOP_SLOT',
    'string-conv-bottom': 'REACT_APP_ADSENSE_STRING_CONV_BOTTOM_SLOT'
  }[slotName];
  
  return envVariable ? process.env[envVariable] || fallbackSlot : fallbackSlot;
};

const AdUnit = ({ adSlot, format = 'auto', style, slotName }) => {
  const [adLoaded, setAdLoaded] = useState(false);
  const [adError, setAdError] = useState(false);
  
  // Get slot from environment variables if slotName is provided
  const finalAdSlot = slotName ? getAdSlotFromEnv(slotName, adSlot) : adSlot;

  useEffect(() => {
    // Check if AdSense is loaded
    if (window.adsbygoogle) {
      try {
        setAdLoaded(true);
        window.adsbygoogle.push({});
      } catch (e) {
        // Silent error handling
        setAdError(true);
      }
    } else {
      // AdSense not loaded yet, wait for it
      const checkAdSense = setInterval(() => {
        if (window.adsbygoogle) {
          clearInterval(checkAdSense);
          try {
            setAdLoaded(true);
            window.adsbygoogle.push({});
          } catch (e) {
            // Silent error handling
            setAdError(true);
          }
        }
      }, 500);

      // Clear interval after 10 seconds if AdSense never loads
      const timeoutId = setTimeout(() => {
        clearInterval(checkAdSense);
        if (!adLoaded) {
          // Silent timeout - don't log error, just set error state
          setAdError(true);
        }
      }, 10000);

      return () => {
        clearInterval(checkAdSense);
        clearTimeout(timeoutId);
      };
    }
  }, [adLoaded]);

  const defaultStyle = {
    display: 'block',
    textAlign: 'center',
    padding: '15px 0',
    overflow: 'hidden',
    width: '100%',
    boxSizing: 'border-box',
  };

  // If ad error, render fallback or empty div with minimal height
  if (adError) {
    return <div style={{ ...defaultStyle, ...style, minHeight: '90px' }} className="ad-error"></div>;
  }

  return (
    <div style={{ ...defaultStyle, ...style }} className="ad-container">
      <ins
        className="adsbygoogle"
        style={{ display: 'block', overflow: 'hidden', maxWidth: '100%' }}
        data-ad-client={ADSENSE_PUB_ID}
        data-ad-slot={finalAdSlot}
        data-ad-format={format}
        data-full-width-responsive="true"
      />
      <style>{`
        @media (max-width: 900px) {
          .ad-container, .ad-error {
            padding: 6px 0 !important;
            min-height: 60px !important;
          }
          .ad-container ins.adsbygoogle {
            min-height: 60px !important;
            height: 60px !important;
          }
        }
      `}</style>
    </div>
  );
};

export default AdUnit; 